import { getTabToken } from "common/MetaActions";
import config from "config/config";
import request from "superagent";

export class MessagesAPI {
  static async getMessagesSummary() {
    try {
      const result = await request
        .get(config.api.messages.summary())
        .set("Authorization", "Bearer " + getTabToken())
        .send();
      return result.body;
    } catch {
      return undefined;
    }
  }

  static async fetchThreads(customerId: string) {
    return await request
      .get(config.api.messages.get(customerId))
      .set("Authorization", "Bearer " + getTabToken())
      .send();
  }
}
